import ProTable, { ActionType, ProColumns } from "@ant-design/pro-table"
import React, { useEffect, useRef, useState } from "react"
import axiosApiInstance from "../../../../api/axiosClient"
import { Button, Form, Input, Spin } from "antd"
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons"
import { useLocation, useNavigate } from "react-router-dom"
import { ModalForm, ProFormSelect, ProFormText } from "@ant-design/pro-form"
import { atom, useAtom, useAtomValue, useSetAtom } from "jotai"
import { assetLabelsAtom, labelsAtom } from "../ddex_atoms"
import { queryClientAtom } from "jotai-tanstack-query"

const isAddNewLabelModalOpen = atom(false)

const { Search } = Input

const NewLabel = () => {
  const [form] = Form.useForm<API.DDEX.Label>()
  const [isOpen, setIsOpen] = useAtom(isAddNewLabelModalOpen)
  const queryClient = useAtomValue(queryClientAtom)
  useAtomValue(assetLabelsAtom)

  return (
    <ModalForm<API.DDEX.Label>
      title="Add new label"
      width={1000}
      form={form}
      labelCol={{ span: 3 }}
      wrapperCol={{ span: 21 }}
      trigger={
        <Button
          type="primary"
          icon={<PlusOutlined />}
          style={{ width: "100%" }}
          onClick={() => setIsOpen(true)}
        >
          Add
        </Button>
      }
      modalProps={{
        destroyOnClose: true,
        onCancel: () => setIsOpen(false),
      }}
      onFinish={async (values) => {
        await axiosApiInstance.post("/api/products/labels/", values)
        // stepFormRef.current?.resetFields(['label_id']);
        queryClient.invalidateQueries({ queryKey: ["labels"] })
        setIsOpen(false)
        return true
      }}
      open={isOpen}
    >
      <ProFormText key={"name"} name={"name"} label="Name" />
      <ProFormText key={"p_line"} name={"p_line"} label="(P) Line" />
      <ProFormText key={"c_line"} name={"c_line"} label="(C) Line" />
      {/* <ProFormSelect
        name={"asset_label_id"}
        label="Asset Label"
        fieldProps={{ loading: statusAssetLabels === "pending" }}
        options={assetLabels?.map((label) => ({
          label: label.name,
          value: label.ID,
        }))}
      /> */}
    </ModalForm>
  )
}

const LabelsTable = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useAtomValue(queryClientAtom)

  const { data: labels, status: statusLabels } = useAtomValue(labelsAtom)

  const [searchText, setSearchText] = useState("")
  const [filteredData, setFilteredData] = useState<
    API.MusicDistribution.Label[]
  >([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (labels) {
      const filtered = labels.filter(
        (label) =>
          label.ID.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          label.name.toLowerCase().includes(searchText.toLowerCase()) ||
          (label.p_line &&
            label.p_line.toLowerCase().includes(searchText.toLowerCase())) ||
          (label.c_line &&
            label.c_line.toLowerCase().includes(searchText.toLowerCase()))
      )
      setFilteredData(filtered)
      setLoading(false)
    }
  }, [searchText, labels])

  const columns: ProColumns<API.MusicDistribution.Label>[] = [
    {
      title: "id",
      key: "id",
      dataIndex: "ID",
      hideInSearch: true,
      hideInForm: true,
    },
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
      hideInSearch: true,
      hideInForm: true,
    },
    {
      title: "(P) Line",
      key: "p_line",
      dataIndex: "p_line",
      hideInSearch: true,
      hideInForm: true,
    },
    {
      title: "(C) Line",
      key: "c_line",
      dataIndex: "c_line",
      hideInSearch: true,
      hideInForm: true,
    },
    {
      title: "",
      key: "actions",
      search: false,
      render(_dom, entity) {
        return (
          <>
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={() =>
                navigate(`/music/labels/${entity.ID}/edit`, {
                  state: { background: location },
                })
              }
            />
            <Button
              type="link"
              icon={<DeleteOutlined />}
              danger
              onClick={() => {
                navigate(`/music/labels/${entity.ID}/delete`, {
                  state: { background: location },
                })
              }}
            />
          </>
        )
      },
    },
  ]
  return (
    <>
      <Search
        placeholder="Search labels..."
        allowClear
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 16 }}
      />
      <Spin spinning={loading}>
        <ProTable
          columns={columns}
          // actionRef={actionRef}
          search={false}
          dataSource={filteredData}
          rowKey="ID"
          options={{
            reload: async () => {
              await queryClient.invalidateQueries({
                queryKey: ["asset_labels"],
              })
            },
          }}
          toolBarRender={() => [<NewLabel />]}
        />
      </Spin>
    </>
  )
}

export default LabelsTable
